const noop = (message?: any, ...optionalParams: any[]) => {};
// window.dev = false;

export const isDebug = process.env.NODE_ENV === "development";

/**
 * Shortcut to call console.log. Won't execute on release builds.
 */
export const trace = isDebug ? console.log.bind(window.console) : noop;

/**
 * Returns a pretty printed string, suitable for debug output.
 * @param {any} obj The object to pretty print.
 */
export function pretty(obj: any) {
  return JSON.stringify(obj, null, "\t");
}

// export { trace, pretty };
